__webpack_require__.p = "https://product-details.qa.core-artifacts.com/static/";